export const projectTitle =
  process.env.REACT_APP_FTL_PROJECT_TITLE || "Заявки на продукцию"

export default projectTitle